import {FileSecurityProps, FileView} from "../components/files/files";
import {API_URL} from "./apiBase";


export const getDownloadLink = (
    file_model: FileView,
    uploadContext: FileSecurityProps,
    props: any
) => {
    // call the download API for an AWS link
    return fetch(`${API_URL}/files/download/v1`, {
        method: "POST",
        body: JSON.stringify({
            project_id: uploadContext.project_id,
            parent_id: uploadContext.parent_id,
            parent_type: uploadContext.parent_type,
            ...file_model,
        }),
        headers: {
            Authorization: `Bearer ${props.accessToken}`,
            "Content-Type": "application/json",
        },
    })
        .then((response) =>
            response.json()
        )
        .then((data) => {
            window.open(data.url, "_blank");
        });
};

export const getDownloadLinkAnon = (
    file_model: FileView,
    uploadContext: FileSecurityProps,

) => {
    // call the download API for an AWS link
    return fetch(`${API_URL}/files/download/v1`, {
        method: "POST",
        body: JSON.stringify({
            project_id: uploadContext.project_id,
            parent_id: uploadContext.parent_id,
            parent_type: uploadContext.parent_type,
            ...file_model,
        }),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) =>
            response.json()
        )
        .then((data) => {
            window.open(data.url, "_blank");
        });
};
